import { createContext } from "react";

import type { EventFilterScope } from "@/features/events/types/event-filter-scope";

export const EventFilterScopeContext = createContext<
	EventFilterScope | undefined
>(undefined);
